import styled from 'styled-components';
import { pulseKeyframes } from '../Shared/SharedStyles';

const RootWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    .ContentLoaderSVG-layer1 {
        width: 100%;
        height: 100%;
        animation: ${pulseKeyframes} 2s infinite;
    }
    .ContentLoaderSVG-layer2 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`;

const PlaceholderSVGLayer1 = () => (
    <svg
        className="ContentLoaderSVG-layer1"
        width="100%"
        height="100%"
        viewBox="0 0 100% 100%"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect id="Rectangle-Copy-2" fillOpacity="0.05" fill="#8E90A2" x="207" y="308" width="653" height="428" rx="2" />
        <rect id="Rectangle-Copy" fillOpacity="0.1" fill="#8E90A2" x="207" y="225" width="532" height="44" rx="2" />
        <rect id="Rectangle-Copy-21" fillOpacity="0.1" fill="#8E90A2" x="207" y="167" width="255" height="44" rx="2" />
        <rect id="Rectangle-Copy-3" fillOpacity="0.1" fill="#8E90A2" x="230" y="329" width="403" height="20" rx="2" />
        <rect id="Rectangle-Copy-6" fillOpacity="0.1" fill="#8E90A2" x="230" y="659" width="403" height="24" rx="2" />
        <rect id="Rectangle-Copy-5" fillOpacity="0.1" fill="#8E90A2" x="230" y="361" width="488" height="20" rx="2" />
        <rect id="Rectangle-Copy-8" fillOpacity="0.1" fill="#8E90A2" x="279" y="435" width="72" height="16" rx="2" />
        <rect id="Rectangle-Copy-15" fillOpacity="0.1" fill="#8E90A2" x="249" y="435" width="16" height="16" rx="8" />
        <rect id="Rectangle-Copy-10" fillOpacity="0.1" fill="#8E90A2" x="279" y="491" width="72" height="16" rx="2" />
        <rect id="Rectangle-Copy-16" fillOpacity="0.1" fill="#8E90A2" x="249" y="491" width="16" height="16" rx="8" />
        <rect id="Rectangle-Copy-12" fillOpacity="0.1" fill="#8E90A2" x="279" y="547" width="72" height="16" rx="2" />
        <rect id="Rectangle-Copy-17" fillOpacity="0.1" fill="#8E90A2" x="249" y="547" width="16" height="16" rx="8" />
        <rect id="Rectangle-Copy-9" fillOpacity="0.1" fill="#8E90A2" x="279" y="463" width="72" height="16" rx="2" />
        <rect id="Rectangle-Copy-18" fillOpacity="0.1" fill="#8E90A2" x="249" y="463" width="16" height="16" rx="8" />
        <rect id="Rectangle-Copy-11" fillOpacity="0.1" fill="#8E90A2" x="279" y="519" width="72" height="16" rx="2" />
        <rect id="Rectangle-Copy-19" fillOpacity="0.1" fill="#8E90A2" x="249" y="519" width="16" height="16" rx="8" />
        <rect id="Rectangle-Copy-13" fillOpacity="0.1" fill="#8E90A2" x="279" y="575" width="72" height="16" rx="2" />
        <rect id="Rectangle-Copy-20" fillOpacity="0.1" fill="#8E90A2" x="249" y="575" width="16" height="16" rx="8" />
        <rect id="Rectangle-Copy-7" fillOpacity="0.1" fill="#8E90A2" x="230" y="697" width="488" height="16" rx="2" />
        <rect id="Rectangle-Copy-4" fillOpacity="0.2" fill="#8E90A2" x="207" y="766" width="180" height="48" rx="2" />
        <rect id="Rectangle-Copy-14" fillOpacity="0.1" fill="#8E90A2" x="132" y="70" width="128" height="32" />
    </svg>
);

const PlaceholderSVGLayer2 = () => (
    <svg
        className="ContentLoaderSVG-layer2"
        width="100%"
        height="100%"
        viewBox="0 0 100% 100%"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect id="bkgd-copy" fill="#424559" x="0" y="40" width="80" height="100%" />
        <rect id="logo" fill="#00C46E" x="0" y="40" width="80" height="80" />
        <rect id="bkgd" x="0" y="0" width="100%" height="40" fill="#424559" />
        <rect
            id="Rectangle"
            x="0"
            y="0"
            width="100%"
            height="164"
            fill="#282B3E"
            transform="translate(80.000000, 874.000000)"
        />
    </svg>
);

const ScreenReaderOnly = styled.span`
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
`;

const FullPageLoadingIndicator = () => (
    <RootWrapper>
        <ScreenReaderOnly>Loading / Chargement</ScreenReaderOnly>
        <PlaceholderSVGLayer1 />
        <PlaceholderSVGLayer2 />
    </RootWrapper>
);

export default FullPageLoadingIndicator;
